import { defineStore } from "pinia";
import { filters } from "@/store/filters";
import dayjs from "dayjs";
import { getShipments } from "@/lib/api";
import { parseResponseAsShipments } from "@/lib/parseResponseAsShipments";
import { dateComparator, getOptionsFromLocalStorage } from "@/lib/utilities";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

export const etaChanges = defineStore("etaChanges", {
  state: () => ({
    shipments: [],
    lastPage: null,
    totalCount: "",
    shipmentsError: false,
    showSpinner: true,
    sortByValue: "latest_updated_eta",
    etaChangedByValue: "all",
    etaChangedByDaysFrom: 1,
    etaChangedByDaysTo: 100,
    sort: "etaLastUpdatedUtc:desc",
    paginationToken: 1
  }),
  actions: {
    setDefaultSortValues() {
      this.sortByValue =
        getOptionsFromLocalStorage(["latest_updated_eta", "new_eta"], "etaTimeFrameSO") || "latest_updated_eta";
      this.etaChangedByValue =
        getOptionsFromLocalStorage(["all", "1_to_3_days", "3_to_7_days", "over_7_days"], "etaSortBySO") || "all";
    },
    async getBookings() {
      try {
        const shipmentsData = [];
        this.showSpinner = true;
        const queryParams = {
          etaChangedByDaysFrom: this.etaChangedByDaysFrom,
          etaChangedByDaysTo: this.etaChangedByDaysTo,
          page: this.paginationToken,
          limit: 25,
          sort: this.sort,
          arrivingFromDateUtc: dayjs().utc().format("YYYY-MM-DD"),
          arrivingToDateUtc: dayjs().utc().add(3, "month").format("YYYY-MM-DD"),
          ...filters().getGlobalFilters
        };
        const response = await getShipments(queryParams, "shipments, tasks");
        shipmentsData.push(...response.data);
        this.shipments = parseResponseAsShipments(
          shipmentsData.sort((a, b) => dateComparator(a.etdUtcAtPlaceOfReceipt, b.etdUtcAtPlaceOfReceipt, null))
        );
        this.totalCount = Number(response.headers["total-count"]);
        this.lastPage = Number(response.headers["last-page"]);
      } catch (e) {
        if (e?.status === 404) {
          this.shipments = [];
          this.totalCount = 0;
          this.lastPage = 0;
          this.shipmentsError = false;
        } else {
          this.shipmentsError = true;
        }
      } finally {
        this.showSpinner = false;
      }
    },
    async updateSortBy($event) {
      this.sortByValue = $event.target.value;
      localStorage.setItem("etaTimeFrameSO", this.sortByValue);
      switch (this.sortByValue) {
        case "latest_updated_eta":
          this.sort = "etaLastUpdatedUtc:desc";
          break;
        case "new_eta":
          this.sort = "etaUtcAtPortOfDischarge:asc";
          break;
      }
      this.paginationToken = 1;
    },
    async updateETAChange($event) {
      this.etaChangedByValue = $event.target.value;
      localStorage.setItem("etaSortBySO", this.etaChangedByValue);
      switch (this.etaChangedByValue) {
        case "all":
          this.etaChangedByDaysFrom = 1;
          this.etaChangedByDaysTo = 100;
          break;
        case "1_to_3_days":
          this.etaChangedByDaysFrom = 1;
          this.etaChangedByDaysTo = 3;
          break;
        case "3_to_7_days":
          this.etaChangedByDaysFrom = 3;
          this.etaChangedByDaysTo = 7;
          break;
        case "over_7_days":
          this.etaChangedByDaysFrom = 7;
          this.etaChangedByDaysTo = 100;
      }
      this.paginationToken = 1;
    },
    updatePaginationToken(pageToken) {
      this.paginationToken = pageToken;
    }
  }
});
